.targetIconsContainer {
  display: flex;
  align-items: center;
  gap: 2px;
}

.targetIcon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.fallbackIcon {
  display: flex;
  align-items: center;
  justify-content: center;
}
